import { render, staticRenderFns } from "./StorageTime.vue?vue&type=template&id=be39a452&scoped=true"
import script from "./StorageTime.vue?vue&type=script&lang=js"
export * from "./StorageTime.vue?vue&type=script&lang=js"
import style0 from "./StorageTime.vue?vue&type=style&index=0&id=be39a452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be39a452",
  null
  
)

export default component.exports